<template>
      <div class="settings">
        <v-container fluid>
          <h1 class="mb-3">Channel Configuration <v-chip v-clipboard:copy="botId" class="cursor-pointer" v-clipboard:success="onCopy">{{botId}} <v-icon small class="pl-2">file_copy</v-icon></v-chip></h1>
          <div class="card-curvey">
            <v-layout>
              <v-flex xs6>

              </v-flex>
            </v-layout>

            <v-layout row wrap>

              <v-flex xs6>
                <label>Direct Line</label>
                <v-text-field
                  class="mt-2"
                  outline
                  v-model="settings.direct_line"
                >
                </v-text-field>
              </v-flex>

              <v-flex xs6>
                <label>External Analytics API URL</label>
                <v-text-field
                  class="mt-2"
                  outline
                  v-model="settings.external_analytics"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <label>Secondary External Analytics API URL</label>
                <v-text-field
                  class="mt-2"
                  outline
                  v-model="settings.external_analytics_second"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <label>Queue Names</label>
                <v-combobox
                  v-model="settings.queueNames"
                  :items="[]"
                  chips
                  outline
                  solo
                  multiple
                >
                </v-combobox>
              </v-flex>
              <v-flex xs6>
                <label>Disabling Bot Expiration Time (Minutes)</label>
                <v-text-field
                  class="mt-2"
                  outline
                  placeholder="Duration in minutes"
                  v-model="settings.disabling_bot_expiration_time"
                />
              </v-flex>
              <v-flex xs6>
                <label>Bot Licence Key</label>
                <v-text-field
                        class="mt-2"
                        outline
                        placeholder="Licence key"
                        v-model="settings.licence_id"
                />
              </v-flex>
              <v-flex xs6>
                <label>Time Zone Shift</label>
                <v-text-field
                    class="mt-2"
                    outline
                    type="number"
                    placeholder="Time zone shift"
                    v-model="settings.timeZoneShift"
                />
              </v-flex>
<!--              <v-flex xs6>-->
<!--                <label for="">Tables Number of Rows Per Page</label>-->
<!--                <v-select-->
<!--                  class="mt-2"-->
<!--                  @change="updateTableNumOfRows"-->
<!--                  outline-->
<!--                  :items="[{text: 5 ,value: 5},{text: 10 ,value: 10},{text: 25 ,value: 25},{text: 'All' ,value: -1} ]"-->
<!--                  item-text="text"-->
<!--                  item-value="value"-->
<!--                  v-model="tableNumOfRows"-->
<!--                  />-->
<!--              </v-flex>-->

            </v-layout>

          </div>




          <v-flex xs12 >
            <v-btn  large round color="primary" @click="updateSettings" :loading="loader">
              Save
            </v-btn>
          </v-flex>
        </v-container>
      </div>
</template>

<script>
  import common from "../../../../utils/common";
  import langIso from "../../../../utils/langIso"
  import fb from './channels-connectors/fb'
  

  export default {
    name: "settings",
    components: {
      fb,
    },
    data () {
      return {
        settings:{
          iframe_link:'',
          direct_line:'',
          facebook_access_token:'',
          external_analytics: '',
          external_analytics_second: '',
          queueNames:[],
          nlp: {

          },
          facebookConnector:{},
          licence_id: '',
          timeZoneShift: '',
        },
        selectedLang: '',
        selectedEngine: '',
        langIso,
        dialog: false,
        tableNumOfRows: 15,
        loader: false
      }
    },
    mounted() {
      this.getSettings()
      this.tableNumOfRows = this.$store.state.settings.pagination.rowsPerPage
    },
    methods: {
      getSettings() {

        this.$http_bot.get('/settings/')
          .then(response=>{
            this.settings = response.data
            if (!this.settings.nlp) {
              this.settings.nlp = {}
            }
            if (!this.settings.facebookConnector) {
              this.settings.facebookConnector = {
                pages: [],
                selectedPage: '',
                appId: '',
                appSecret: ''
              }

            }
            if (this.facebookAutoCred === 'true') {
              this.settings.facebookConnector.appId = process.env.VUE_APP_FACEBOOK_APP_ID
            }
            this.$store.dispatch('setSettings', this.settings)

          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()

            }
          })
      },
      updateSettings() {
        this.loader = true
        this.$http.put('/settings/', {
          bot_id: this.botId,
          settings: this.settings
        }) .then(response=>{
          this.$store.dispatch('setSettings',this.settings)
          if (this.settings.facebookConnector.selectedPage.id) {
            this.updateFacebookSelectedPage()
          }
          this.$store.dispatch('setSettings', this.settings)
          this.updateBotLicenceKey()
        })
          .catch(error=>{
            this.loader = false
            if (error.response.status === 401) {
              common.logOut()
            }
          })
      },
      updateBotLicenceKey () {
        this.$http_session_manager.put(`/bots/${this.$store.state.bot.botId}`,{
          licence_id: this.settings.licence_id
        })
        .then(res=>{
          this.loader = false
          this.$store.dispatch('setSnackbar', {
            text: `Updated successfully `,
            color: 'success',
            status: true
          })
        })
        .catch(err=>{
          this.loader = false
          this.$store.dispatch('setSnackbar', {
            text: `Something went wrong`,
            color: 'error',
            status: true
          })
        })
      },
      async updateFacebookSelectedPage () {
        let image = await this.getFacebookPageImage()

        await this.$http_session_manager.put(`/bots/${this.$store.state.bot.botId}/apps/facebook`,{
          page_id: this.settings.facebookConnector.selectedPage.id,
          app_secret: this.settings.facebookConnector.appSecret ? this.settings.facebookConnector.appSecret : '' ,
          access_token: this.settings.facebookConnector.selectedPage.access_token,
          name: this.settings.facebookConnector.selectedPage.name,
          verify_token: '',
          image: image.data.data.url
        })
        .then(response=> {

        })
        .catch(error=>{
          if (error.response.status === 401) {
            common.logOut()
          }
        })
      },
      async getFacebookPageImage () {
        return  this.$http_without_base.get(`https://graph.facebook.com/v8.0/${this.settings.facebookConnector.selectedPage.id}/picture?redirect=0`)
      },
      pushLang () {
        if (!this.settings.nlp[this.selectedLang]) {
          this.settings.nlp[this.selectedLang] = {
            engine: this.selectedEngine,
            min_score: '',
            app_id: '',
            api_key: '',
            hostname: '',
          }
          this.selectedLang = ''
          this.selectedEngine = ''
          this.dialog = false
        }
      },
      deleteLang (lang) {
        delete this.settings.nlp[lang]
        this.selectedLang = ''
        this.$forceUpdate();
      },
      getLang(code) {
        let index = this.langIso.findIndex( item=> {
          return item.code === code
        })
        return this.langIso[index].name
      },
      onCopy() {
        this.$store.dispatch('setSnackbar',{
          text: 'Text copied to your clipboard',
          color: 'primary',
          status: true
        })
      },
      setFacebookPages(pages) {
        this.settings.facebookConnector.pages= pages
        this.$forceUpdate()
      },
      updateTableNumOfRows (){
        this.$store.dispatch('setTableNumberOfRows', this.tableNumOfRows)
      }
    },

    computed: {
      botId() {
        return this.$store.state.bot.botId
      },
      facebookAutoCred () {
        return process.env.VUE_APP_FACEBOOK_AUTO_PUBLISHER_CREDENTIAL
      }
    }
  }
</script>

<style scoped>
  .btn-input {
    height: 45px;
  }
  .add-lang {
    max-width: 500px;
    margin: auto;
  }
</style>
